import { type AccountCode } from '@webapp/models'
import { ApiClient, type IApiRequestParam } from '../services/api'

export const ENDPOINT = '/api/v3/account-codes'

export const ACCOUNT_CODES_URL = ENDPOINT

export class AccountCodesAPI {
  static readonly getAccountCodes = (params: IApiRequestParam = {}) =>
    ApiClient.get<AccountCode[]>(`${ACCOUNT_CODES_URL}/`, { params })

  static readonly getAccountCodeDetails = (accountCodeId: AccountCode['id']) =>
    ApiClient.get<{}, AccountCode>(`${ACCOUNT_CODES_URL}/${accountCodeId}/`)

  static readonly updateAccountCode = (
    accountCodeId: AccountCode['id'],
    accountCode: Partial<AccountCode>
  ) =>
    ApiClient.patch<Partial<AccountCode>, AccountCode>(
      `${ACCOUNT_CODES_URL}/${accountCodeId}/`,
      accountCode
    )
}
